import { Record, Union } from "../fable_modules/fable-library-js.4.25.0/Types.js";
import { MediaViewModel_$reflection } from "../ThreeDocs.Models/View/MediaViewModel.js";
import { lambda_type, list_type, unit_type, record_type, option_type, class_type, string_type, union_type } from "../fable_modules/fable-library-js.4.25.0/Reflection.js";
import { ofArray } from "../fable_modules/fable-library-js.4.25.0/List.js";
import { S3Context_$reflection } from "../Common/AwsCommon.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.25.0/Result.js";
import { Sort_SortInfo$1_$reflection } from "../ThreeDocs.SharedUI/Sort.js";
import { UserRole_$reflection } from "../ThreeDocs.Models/Security.js";
import { OutboundMsg_$reflection, InboundMsg_$reflection, LocalMsg_$reflection, Model_$reflection as Model_$reflection_1 } from "../FileManagement/FileManagementTypes.js";
import { ChainedChildMsg$2_$reflection, ChildAbsentStrategy$1_$reflection, DefaultActions_Types_ChildModel$2_$reflection } from "../Common/Terminate.js";
import { OutboundMsg_$reflection as OutboundMsg_$reflection_1, InboundMsg_$reflection as InboundMsg_$reflection_1, LocalMsg_$reflection as LocalMsg_$reflection_1, Model_$reflection as Model_$reflection_2 } from "../FileManagement/FileUploadSelectors/DragDropFileSelector/DragDropTypes.js";
import { Notification_$reflection, ErrorMessage_$reflection } from "../ThreeDocs.Models/Api/Api.js";
import { InOut_Msg$3_$reflection } from "../Common/Common.js";

export class ViewMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["List", "Detail", "Create", "Edit", "Delete"];
    }
}

export function ViewMode_$reflection() {
    return union_type("ThreeDocs.Client.Media.Types.ViewMode", [], ViewMode, () => [[], [["Item", MediaViewModel_$reflection()]], [], [["Item", MediaViewModel_$reflection()]], []]);
}

export class MediaFilter extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GeneralMedia", "PracticeMedia", "AllMedia"];
    }
}

export function MediaFilter_$reflection() {
    return union_type("ThreeDocs.Client.Media.Types.MediaFilter", [], MediaFilter, () => [[], [], []]);
}

export function MediaFilter_get_all() {
    return ofArray([new MediaFilter(0, []), new MediaFilter(1, []), new MediaFilter(2, [])]);
}

export function MediaFilter_get_describe() {
    return (_arg) => ((_arg.tag === 1) ? "Practice Media" : ((_arg.tag === 2) ? "All Media" : "3Docs Media"));
}

export class MediaUpdateArgs extends Record {
    constructor(Token, MaybeCredentials, MaybeS3Context) {
        super();
        this.Token = Token;
        this.MaybeCredentials = MaybeCredentials;
        this.MaybeS3Context = MaybeS3Context;
    }
}

export function MediaUpdateArgs_$reflection() {
    return record_type("ThreeDocs.Client.Media.Types.MediaUpdateArgs", [], MediaUpdateArgs, () => [["Token", string_type], ["MaybeCredentials", option_type(class_type("Fable.Import.Aws.Credentials.Credentials"))], ["MaybeS3Context", option_type(S3Context_$reflection())]]);
}

export class Model extends Record {
    constructor(ViewMode, MediaFilter, SelectedMedia, IsSelectedMediaValid, SortInfo, CurrentRoles, PracticeMedia, PublicMedia, dragDropFileManagementModel, dragDropModel) {
        super();
        this.ViewMode = ViewMode;
        this.MediaFilter = MediaFilter;
        this.SelectedMedia = SelectedMedia;
        this.IsSelectedMediaValid = IsSelectedMediaValid;
        this.SortInfo = SortInfo;
        this.CurrentRoles = CurrentRoles;
        this.PracticeMedia = PracticeMedia;
        this.PublicMedia = PublicMedia;
        this.dragDropFileManagementModel = dragDropFileManagementModel;
        this.dragDropModel = dragDropModel;
    }
}

export function Model_$reflection() {
    return record_type("ThreeDocs.Client.Media.Types.Model", [], Model, () => [["ViewMode", ViewMode_$reflection()], ["MediaFilter", MediaFilter_$reflection()], ["SelectedMedia", MediaViewModel_$reflection()], ["IsSelectedMediaValid", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, option_type(string_type)], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", option_type(string_type)]]])], ["SortInfo", Sort_SortInfo$1_$reflection(MediaViewModel_$reflection())], ["CurrentRoles", list_type(UserRole_$reflection())], ["PracticeMedia", list_type(MediaViewModel_$reflection())], ["PublicMedia", list_type(MediaViewModel_$reflection())], ["dragDropFileManagementModel", DefaultActions_Types_ChildModel$2_$reflection(Model_$reflection_1(), Model_$reflection())], ["dragDropModel", Model_$reflection_2()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExceptionError", "Authenticated", "SetMediaVm", "SetViewMode", "SetMediaFilter", "UpdateSortInfo", "ValidateSelectedMedia", "CreateMedia", "CreateMediaResult", "UpdateMedia", "UpdateMediaResult", "DeleteMedia", "DeleteMediaResult", "GetPublicMedia", "GetPublicMediaResult", "GetMediaForPractice", "GetMediaForPracticeResult", "Notification", "CreateFileManagement", "TerminateFileManagement", "ClearDragDropChildrenLists", "DragDropFileManagementMsg", "DragDropMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("ThreeDocs.Client.Media.Types.Msg", [], Msg, () => [[["Item", class_type("System.Exception")]], [], [["Item", lambda_type(MediaViewModel_$reflection(), MediaViewModel_$reflection())]], [["Item", ViewMode_$reflection()]], [["Item", MediaFilter_$reflection()]], [["Item", Sort_SortInfo$1_$reflection(MediaViewModel_$reflection())]], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [MediaViewModel_$reflection(), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", MediaViewModel_$reflection()]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [MediaViewModel_$reflection(), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", MediaViewModel_$reflection()]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(MediaViewModel_$reflection()), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(MediaViewModel_$reflection())]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", class_type("System.Guid")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(MediaViewModel_$reflection()), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(MediaViewModel_$reflection())]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", Notification_$reflection()]], [], [], [], [["Item", ChainedChildMsg$2_$reflection(InOut_Msg$3_$reflection(LocalMsg_$reflection(), InboundMsg_$reflection(), OutboundMsg_$reflection()), ChildAbsentStrategy$1_$reflection(Model_$reflection()))]], [["Item", InOut_Msg$3_$reflection(LocalMsg_$reflection_1(), InboundMsg_$reflection_1(), OutboundMsg_$reflection_1())]]]);
}

